import { render, staticRenderFns } from "./ClientDetailsConfigurator.vue?vue&type=template&id=69888e68"
import script from "./ClientDetailsConfigurator.vue?vue&type=script&lang=js"
export * from "./ClientDetailsConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports